import PageContainer from 'layouts/PageContainer'
import { useState } from 'react'
import MilkYeildTable from './components/MilkYeild-Table/MilkYeildTable'
import MilkYeildCard from './components/MilkYeildCard/MilkYeildCard'

const MilkYeildPage = () => {
	const [selectedBarn, setSelectedBarn] = useState<number | null>(null)
	const [selectedGroup, setSelectedGroup] = useState<number[]>([])

	return (
		<PageContainer>
			<MilkYeildCard
				selectedBarn={selectedBarn}
				setSelectedBarn={setSelectedBarn}
				selectedGroup={selectedGroup}
				setSelectedGroup={setSelectedGroup}
			/>
			<MilkYeildTable
				selectedBarn={selectedBarn}
				selectedGroup={selectedGroup}
			/>
		</PageContainer>
	)
}

export default MilkYeildPage
